import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { NullableCommunique } from 'types/types';

const initialState: NullableCommunique = null;

export const communiqueSlice = createSlice({
  name: 'communique',
  initialState,
  reducers: {
    communiqueAction: (state, action: PayloadAction<any>) => action.payload,
  },
});

// Action creators are generated for each case reducer function
export const { communiqueAction } = communiqueSlice.actions;

export default communiqueSlice.reducer;
